import React, { useEffect, useRef, useState } from 'react'
import LeftBar from '../Components/LeftBar'
import Topbar from '../Components/Topbar'
import profDefault from '../Images/def.png'
import defaultCover from '../Images/coverbg.jpg'
import { useNavigate } from 'react-router-dom'
import BottomNav from '../Components/BottomNav'
import Form from "react-bootstrap/Form"
import Spinner from 'react-bootstrap/Spinner';
import { Modal } from 'react-bootstrap'
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faTiktok, faYoutube, faLinkedin, faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons"
import ProgressBar from 'react-bootstrap/ProgressBar';
import { app } from "../firebase.js"
import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, updateDoc, getFirestore, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import swal from 'sweetalert';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { Link } from 'react-router-dom'

function UserNameSetup() {



    const db = getFirestore(app);
    const [userId, setUserId] = useState()
    const auth = getAuth();
    const navigate = useNavigate();

    const usernameRef = useRef();
    const [currentUsername, setCurrentUsername] = useState('');
    const [loggedIntheUsername, setloggedIntheUsername] = useState();

    const [saveButton4, setsaveButton4] = useState(true);
    const [updateButton4, setupdateButton4] = useState(false);

    const typingTimeout = useRef(null);

    //get the currently signed in user
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const uid = user.uid;
                setUserId(uid)
                const docRef = doc(db, "users", uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();

                    setloggedIntheUsername(data.theUsername || "")

                    setCurrentUsername(data.theUsername || "");

                } else {
                    console.log("No such document!");
                }
            } else {
                navigate("/login");
            }
        });

        return () => unsubscribe();
    }, [navigate, auth]);


    const [usernameAvailable, setUsernameAvailable] = useState(true)
    const [usernameSuggestions, setUsernameSuggestions] = useState([])

    function sanitizeUsername(raw) {
        return raw
            .toLowerCase()
            .replace(/@/g, '')          // remove @
            .replace(/\s+/g, '')        // remove spaces
            .replace(/[^a-z0-9._]/g, ''); // allow only safe chars
    }

    async function checkUsername(e) {
        const value = sanitizeUsername(e.target.value);

        if (usernameRef.current) {
            usernameRef.current.value = value;
        }

        if (typingTimeout.current) {
            clearTimeout(typingTimeout.current);
        }

        typingTimeout.current = setTimeout(async () => {
            if (value.length < 3 || value === currentUsername) {
                setUsernameAvailable(true);
                setUsernameSuggestions([]);
                return;
            }

            const dbRef = doc(db, "usernames", value);
            const snap = await getDoc(dbRef);

            if (snap.exists()) {
                setUsernameAvailable(false);
                setUsernameSuggestions([
                    value + Math.floor(Math.random() * 99),
                    value + "_" + Math.floor(Math.random() * 999),
                    value + "official"
                ]);
            } else {
                setUsernameAvailable(true);
                setUsernameSuggestions([]);
            }
        }, 350);
    }


    async function saveUsername(goNext = false) {
        const user = auth.currentUser;
        if (!user) return;

        setsaveButton4(false)
        setupdateButton4(true)

        let value = sanitizeUsername(usernameRef.current.value);

        if (!value || value.length < 3) {
            setsaveButton4(true)
            setupdateButton4(false)
            swal("Error", "Username must be at least 3 characters", "error");
            return;
        }

        if (!/^[a-z0-9._]{3,}$/.test(value)) {
            setsaveButton4(true);
            setupdateButton4(false);
            swal(
                "Error",
                "Username can only contain lowercase letters, numbers, dot and underscore",
                "error"
            );
            return;
        }


        if (value === currentUsername) {
            await updateDoc(doc(db, "users", user.uid), {
                onboardingStep: 2,
                onboardingCompleted: false
            });

            setsaveButton4(true)
            setupdateButton4(false)

            if (goNext) {
                navigate("/social-setup");
            } else {
                swal("Info", "Username unchanged", "info");
            }
            return;
        }

        const usernameDocRef = doc(db, "usernames", value);
        const snap = await getDoc(usernameDocRef);

        if (snap.exists()) {
            setsaveButton4(true)
            setupdateButton4(false)
            swal("Error", "Username already taken", "error");
            return;
        }

        try {
            if (currentUsername) {
                await deleteDoc(doc(db, "usernames", currentUsername));
            }

            await setDoc(usernameDocRef, { uid: user.uid });

            await updateDoc(doc(db, "users", user.uid), {
                theUsername: value,
                onboardingStep: 2,
                onboardingCompleted: false
            });

            setCurrentUsername(value);

            setsaveButton4(true)
            setupdateButton4(false)

            if (goNext) {
                navigate("/social-setup");
            } else {
                swal("Success", "Username updated", "success");
            }

        } catch (err) {
            console.error(err);
            setsaveButton4(true)
            setupdateButton4(false)
            swal("Error", "Failed to update username", "error");
        }
    }



    return (
        <div className='mainDashboard'>
            <div className="desktopOnly">
                <LeftBar />
            </div>

            <div className='mainContent'>
                <Topbar />

                <div className='editFormSection'>

                    <Form.Label className='sectionTitle'>Set your username</Form.Label>

                    <Form.Control
                        type="text"
                        onChange={checkUsername}
                        defaultValue={loggedIntheUsername}
                        placeholder="username"
                        ref={usernameRef}
                        autoCapitalize="none"
                        autoCorrect="off"
                    />


                    {usernameAvailable ? (
                        <p className="status success">Available</p>
                    ) : (
                        <p className="status error">Not available</p>
                    )}


                    <div className="formActions">
                        <button
                            type="button"
                            className="secondaryBtn"
                            onClick={() => navigate("/edit-profile")}
                        >
                            Previous
                        </button>

                        {saveButton4 && (
                            <>
                                <button
                                    type="button"
                                    className="secondaryBtn"
                                    disabled={!usernameAvailable}
                                    onClick={() => saveUsername(false)}
                                >
                                    Save
                                </button>


                                <button
                                    type="button"
                                    className="primaryBtn"
                                    disabled={!usernameAvailable}
                                    onClick={() => saveUsername(true)}
                                >
                                    Save & Next
                                </button>

                            </>
                        )}

                        {updateButton4 && (
                            <Button disabled className="primaryBtn">
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                {" "}Saving...
                            </Button>
                        )}
                    </div>



                </div>
            </div>
            <div className="mobileOnly">
                <BottomNav />
            </div>

        </div>
    )
}

export default UserNameSetup